module.exports = __webpack_public_path__ + "static/media/pdl-card.aaa545f9.png";